import {
  FORM_FIELD_TEXTAREA,
  FORM_FIELD_IMAGE,
  FORM_FIELD_IMAGES_SET,
} from '@developer/config';

export const FIELD_APP_DESCRIPTION_URL = 'desc_url',
  FIELD_APP_DESCRIPTION_LONG_DESC = 'long_description',
  FIELD_APP_DESCRIPTION_APP_ICON = 'appDescLongAppIcon',
  FIELD_APP_DESCRIPTION_PREVIEW_IMAGES = 'appDescLongPreviewImages',
  //
  appDescriptionFields = {
    url: {
      id: 'desc_url',
      name: 'desc_url',
      labelContent: 'form_dashboard_app_description_url',
      ui: {
        type: FORM_FIELD_TEXTAREA,
      },
    },
    longDesc: {
      id: 'long_description',
      name: 'long_description',
      labelContent: 'form_dashboard_app_description_long_desc',
      ui: {
        type: FORM_FIELD_TEXTAREA,
      },
    },
    appIcon: {
      id: FIELD_APP_DESCRIPTION_APP_ICON,
      name: FIELD_APP_DESCRIPTION_APP_ICON,
      isRequired: true,
      labelContent: 'form_dashboard_app_description_app_icon',
      ui: {
        type: FORM_FIELD_IMAGE,
      },
      validations: {
        required: false, // TODO: change this to 'true' when image uploading will be presented
      },
    },
    previewImages: {
      id: FIELD_APP_DESCRIPTION_PREVIEW_IMAGES,
      name: FIELD_APP_DESCRIPTION_PREVIEW_IMAGES,
      isRequired: true,
      labelContent: 'form_dashboard_app_description_preview_images',
      ui: {
        type: FORM_FIELD_IMAGES_SET,
      },
      validations: {
        required: false, // TODO: change this to 'true' when image uploading will be presented
      },
    },
  };
